interface TableRowProps {
  selected?: boolean;
  className?: string;
  title?: string;
}

export const TableRow: React.FC<React.PropsWithChildren<TableRowProps>> = ({
  selected,
  className,
  title,
  children,
}) => {
  return (
    <tr
      className={`even:bg-slate-50/90 aria-selected:bg-blue-100 aria-selected:even:bg-blue-200 ${className}`}
      aria-selected={selected}
      title={title}
    >
      {children}
    </tr>
  );
};
